import React from "react";
import { Layout, Menu } from "antd";
import { HomeOutlined, CarOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Sider } = Layout;

const AccessedCarNavigation = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const menuItems = [
		{
			key: "/utils/accessed-car/view-accessed-cars",
			icon: <CarOutlined />,
			label: "교인 차량 등록 및 조회",
		},
		{
			key: "/utils/etal-car/view-etar-cars",
			icon: <CarOutlined />,
			label: "이탈 차량 등록 및 조회",
		},
		{
			key: "/utils/rent-cars",
			icon: <CarOutlined />,
			label: "차량 대여 및 운행 일정",
		},
		{
			key: "/utils/rent-cars/maintenance",
			icon: <CarOutlined />,
			label: "차량 검사·수리 일정",
		},
		// {
		// 	key: "/utils/rent-cars/applications",
		// 	icon: <CarOutlined />,
		// 	label: "차량 대여 신청 관리",
		// },
		{
			key: "/utils/vehicle-insurance",
			icon: <CarOutlined />,
			label: "차량 보험 관리",
		},
		{
			key: "/utils/car-types",
			icon: <CarOutlined />,
			label: "차량 목록 관리",
		},
	];

	const handleMenuClick = ({ key }) => {
		navigate(key);
	};

	const getSelectedKey = () => {
		const path = location.pathname.replace(/\/$/, "") || "/";
		const sorted = [...menuItems].sort(
			(a, b) => b.key.length - a.key.length,
		);
		const menuItem = sorted.find(
			(item) =>
				path === item.key ||
				path.startsWith(`${item.key}/`),
		);
		return menuItem
			? menuItem.key
			: "/utils/accessed-car/view-accessed-cars";
	};

	return (
		<Sider
			width={250}
			className="member-navigation__sider"
			breakpoint="lg"
			collapsedWidth="0">
			<div className="member-navigation__logo">
				<HomeOutlined />
				<span>차량 관리</span>
			</div>
			<Menu
				mode="inline"
				theme="dark"
				selectedKeys={[getSelectedKey()]}
				items={menuItems}
				onClick={handleMenuClick}
				className="member-navigation__menu"
			/>
		</Sider>
	);
};

export default AccessedCarNavigation;
